import { Mail, Trash2 } from 'lucide-react';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { DropdownAction } from '@/components/ui/dropdown-actions';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

import { useToggle } from '@/hooks/use-toggle';

import { useResendInvitationMutation } from '@/query/user.query';

import { Permissions } from '@/constants';

import { RemoveUser } from './remove-user';

import { type User,USER_STATUS } from '@/types/user.type';

type Props = {
  member: User;
};

export const RowAction = ({ member }: Props) => {
  const { state, toggle } = useToggle();
  const resendInvitationMutation = useResendInvitationMutation();

  return (
    <div onClick={e => e.stopPropagation()}>
      <ProtectedComponent
        requiredPermissions={[Permissions.UsersRemoveUser, Permissions.UsersInvite]}
      >
        <DropdownAction>
          <ProtectedComponent requiredPermissions={[Permissions.UsersInvite]}>
            {member.status === USER_STATUS.Invited && (
              <>
                <DropdownMenuItem
                  disabled={resendInvitationMutation.isPending}
                  onClick={() => resendInvitationMutation.mutate(member.id)}
                >
                  <Mail className="h-4 w-4" />
                  Resend invitation
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}
          </ProtectedComponent>
          <ProtectedComponent requiredPermissions={[Permissions.UsersRemoveUser]}>
            <DropdownMenuItem variant="destructive" onClick={toggle}>
              <Trash2 className="h-4 w-4" />
              Remove member
            </DropdownMenuItem>
          </ProtectedComponent>
        </DropdownAction>
      </ProtectedComponent>

      {state && <RemoveUser user={member} toggle={toggle} />}
    </div>
  );
};
